<script lang="ts">
  import i18n from '../../../i18n'
  import { ToggleGroup, ToggleGroupItem } from '../../../components/toggle-group'
  import { OrthographicCamera, PerspectiveCamera } from '../../../components/icons'
  import { cameraType } from '../../../stores/camera'
</script>

<ToggleGroup
  variant="secondary"
  name="camera"
  size="lg"
  type="single"
  bind:value={$cameraType}
>
  <ToggleGroupItem
    title={$i18n.t('project.camera.type.perspective')}
    value="perspective"
  >
    <PerspectiveCamera />
  </ToggleGroupItem>
  <ToggleGroupItem
    title={$i18n.t('project.camera.type.orthographic')}
    value="orthographic"
  >
    <OrthographicCamera />
  </ToggleGroupItem>
</ToggleGroup>
